
var mensLongSleeveShirts = {
  category: "Men's",
  product: "Long Sleeve Shirts + Pullovers",
  sections: [{
      section: {
        title: "Size Chart",
        type: "table",
        header: [
          "Shirt Size","",
          "Your Chest",
          "Your Arm",
          "Your Neck"
        ],
        rows: [
          [
            "XS","",
            "33 - 35",
            "32 - 33",
            "13.5 - 14"
          ],
          [
            "S","",
            "36 - 38",
            "33 - 34",
            "14.5 - 15"
          ],
          [
            "M","",
            "39 - 41",
            "34 - 35",
            "15.5 - 16"
          ],
          [
            "L","",
            "42 - 44",
            "35 - 36",
            "16.5 - 17"
          ],
          [
            "XL","",
            "45 -47",
            "36 - 37",
            "17.5 - 18"
          ],
          [
            "XXL","",
            "48 - 50",
            "37 - 38",
            "18.5 - 19"
          ]
        ]
      }
    },
    {
      section: {
        title: "Fit Guidance",
        type: "twoCol",
        columns: [
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Men_s_LS_Shirts_-_Classic_Fit.png?14026",
            title: "Classic:",
            body: "A tapered silhouette and modern fit, with room for movement in the chest, arms, and waist."
          }],
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Men_s_LS_Shirts_-_Slim_Fit.png?14026",
            title: "Slim Fit:",
            body: "A tapered silhouette with a more contemporary fit, slimmer throughout the chest, arms, and waist than our Classic Fit."
          }]
        ]
      }
    },
    {
      section: {
        title: 'Length Guidance',
        type: "twoCol",
        columns: [
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Men_s_LS_Shirts_-_Regular_Length.png?16962",
            title: "Regular:",
            body: "Our standard length, with the hem hitting just below the waistline."
          }],
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Men_s_LS_Shirts_-_Tall_Length.png?16962",
            title: "Tall:",
            body: "1.5” (3.8 cm) longer in the body and sleeve than our Regular Length."
          }]
        ]
      }
    },
    {
      section: {
        title: 'How to Measure',
        type: "singleCol",
        columns: [
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Mens_-_How_To_Measure.png?14026"
          }],
          [{
            title: "Neck: ",
            body: "Wrap the measuring tape loosely around the base of your neck, keeping one finger between your neck and the tape."
          }],
          [{
            title: "Arm (Spine to Wrist): ",
            body: "The arm measurement used for sleeve length is measured from the center back of the neck to wrist. Hold your arm out to the side with your elbow slightly bent, and measure from the back center of your neck (your spine) down the outside of your arm to your wrist bone."
          }],
          [{
            title: "Chest: ",
            body: "Wrap the measuring tape around the circumference of your chest at the widest point, approximately 1\"/2.5 cm below your armpit. Inhale, exhale, and then place a finger behind the tape. Keep the tape level and snug, but not too tight."
          }],
          [{
            title: "Natural Waist: ",
            body: "Bend to the side to find the natural crease of your waist. Wrap the measuring tape at this point, keeping the tape slightly loose."
          }],
          [{
            title: "Waist: ",
            body: "Wrap the measuring tape around your waistline (where you want your pants to sit), keeping the tape slightly loose. Bluffworks pants are offered in 1\"/2.5 cm increments, so we suggest sizing up if you're between sizes."
          }],
          [{
            title: "Hips: ",
            body: "Keep feet together, and wrap the measuring tape around the fullest part of your seat (approximately 8\"/20.3 cm below your natural waist), keeping the tape slightly loose."
          }],
          [{
            title: "Thigh: ",
            body: "Wrap the measuring tape around the fullest part of the thigh (approximately 1\"/2.5 cm below the crotch), keeping the tape slightly loose."
          }]
        ]
      }
    }
  ]
};

var mensShortSleeveShirts = {
  category: "Men's",
  product: "Short Sleeve Shirts",
  sections: [{
      section: {
        title: "Size Chart",
        type: "table",
        header: [
          "Shirt Size","",
          "Your Chest",
          "Your Arm",
          "Your Neck"
        ],
        rows: [
          [
            "XS","",
            "33 - 35",
            "32 - 33",
            "13.5 - 14"
          ],
          [
            "S","",
            "36 - 38",
            "33 - 34",
            "14.5 - 15"
          ],
          [
            "M","",
            "39 - 41",
            "34 - 35",
            "15.5 - 16"
          ],
          [
            "L","",
            "42 - 44",
            "35 - 36",
            "16.5 - 17"
          ],
          [
            "XL","",
            "45 -47",
            "36 - 37",
            "17.5 - 18"
          ],
          [
            "XXL","",
            "48 - 50",
            "37 - 38",
            "18.5 - 19"
          ]
        ]
      }
    },
    {
      section: {
        title: "Fit Guidance",
        type: "twoCol",
        columns: [
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Men_s_SS_Shirts_-_Classic_Fit.png?14266",
            title: "Classic:",
            body: "A tapered silhouette and modern fit, with room for movement in the chest, arms, and waist."
          }],
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Men_s_SS_Shirts_-_Slim_Fit.png?14266",
            title: "Slim:",
            body: "A tapered silhouette with a more contemporary fit, slimmer throughout the chest, arms, and waist than our Classic Fit."
          }]
        ]
      }
    },
    {
      section: {
        title: 'Length Guidance',
        type: "twoCol",
        columns: [
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Men_s_SS_Shirts_-_Regular_Length.png?14264",
            title: "Regular:",
            body: "Our standard length, with the hem hitting just below the waistline."
          }],
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Men_s_SS_Shirts_-_Tall_Length.png?14264",
            title: "Tall:",
            body: "2” (5 cm) longer in the body and 0.5” (1.3 cm) longer in the sleeve than our Regular Length."
          }]
        ]
      }
    },
    {
      section: {
        title: 'How to Measure',
        type: "singleCol",
        columns: [
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Mens_-_How_To_Measure.png?14026"
          }],
          [{
            title: "Neck: ",
            body: "Wrap the measuring tape loosely around the base of your neck, keeping one finger between your neck and the tape."
          }],
          [{
            title: "Arm (Spine to Wrist): ",
            body: "The arm measurement used for sleeve length is measured from the center back of the neck to wrist. Hold your arm out to the side with your elbow slightly bent, and measure from the back center of your neck (your spine) down the outside of your arm to your wrist bone."
          }],
          [{
            title: "Chest: ",
            body: "Wrap the measuring tape around the circumference of your chest at the widest point, approximately 1\"/2.5 cm below your armpit. Inhale, exhale, and then place a finger behind the tape. Keep the tape level and snug, but not too tight."
          }],
          [{
            title: "Natural Waist: ",
            body: "Bend to the side to find the natural crease of your waist. Wrap the measuring tape at this point, keeping the tape slightly loose."
          }],
          [{
            title: "Waist: ",
            body: "Wrap the measuring tape around your waistline (where you want your pants to sit), keeping the tape slightly loose. Bluffworks pants are offered in 1\"/2.5 cm increments, so we suggest sizing up if you're between sizes."
          }],
          [{
            title: "Hips: ",
            body: "Keep feet together, and wrap the measuring tape around the fullest part of your seat (approximately 8\"/20.3 cm below your natural waist), keeping the tape slightly loose."
          }],
          [{
            title: "Thigh: ",
            body: "Wrap the measuring tape around the fullest part of the thigh (approximately 1\"/2.5 cm below the crotch), keeping the tape slightly loose."
          }]
        ]
      }
    }
  ]
};